module.exports = __webpack_public_path__ + "img/NIS_SupplyChain.2ad0a619.svg";